import { Card, CardBody, CardHeader, CardTitle } from '@/components/ui/card';
import { Field, Mono, PageHeader } from '@/components/ui/primitives';
import { formatTime } from '@/lib/api';
import { useSession } from '@/lib/session';

export function SessionPage() {
  const { session } = useSession();
  if (!session) return null;
  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <PageHeader
        title="Current user and session"
        description="What the platform knows about your signed-in session. No tokens are held by the browser."
      />
      <Card>
        <CardHeader>
          <CardTitle>Identity</CardTitle>
        </CardHeader>
        <CardBody>
          <dl className="grid gap-4 sm:grid-cols-2">
            <Field label="Name" value={session.principal.displayName ?? '—'} />
            <Field label="E-mail" value={session.principal.email ?? '—'} />
            <Field label="User ID" value={<Mono>{session.principal.userId}</Mono>} />
            <Field
              label="Client"
              value={<Mono>{`${session.client.clientId} (${session.client.kind})`}</Mono>}
            />
            <Field
              label="Organization"
              value={
                session.organization
                  ? `${session.organization.name} (${session.organization.slug})`
                  : '—'
              }
            />
            <Field label="Roles" value={session.roles.join(', ') || '—'} />
            <Field label="Capabilities" value={session.capabilities.join(', ') || '—'} />
            <Field label="Session idle expiry" value={formatTime(session.expiresAt)} />
          </dl>
        </CardBody>
      </Card>
    </div>
  );
}
